import styled, { css } from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { media } from '@simplywallst/ui-core';

interface Props {
  criteriaVisible: boolean;
}

export const ContentWrapper = styled('div')`
  display: none;
`;

export const Wrapper = styled(Grid)<Props>`
  position: relative;
  margin-top: -${({ theme }) => theme.x3spacePx}px;
  background: ${({ theme }) => theme.color.noir};
  border-bottom-left-radius: ${({ theme }) => theme.x1spacePx}px;
  border-bottom-right-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x4spacePx}px;
  padding-top: ${({ theme }) => theme.x3spacePx}px;
  ${media.mdDown`
    padding: ${({ theme }) => theme.x2spacePx}px;
    border-radius: 0;
  `}
  ${({ theme, criteriaVisible }) =>
    criteriaVisible === false &&
    css`
      padding-bottom: ${theme.x3spacePx}px;
      ${media.mdDown`
      padding-bottom: ${theme.x2spacePx}px;
    `}
    `}

  ${ContentWrapper} {
    ${({ theme, criteriaVisible }) =>
      criteriaVisible &&
      css`
        display: block;
        background: ${theme.color.charcoal};
        border-bottom-left-radius: ${theme.x1spacePx}px;
        border-bottom-right-radius: ${theme.x1spacePx}px;
        color: ${theme.color.whiteRGBA(0.7)};
        padding: ${theme.x2spacePx}px;
        padding-bottom: 0;
        ul {
          ${theme.typography.xSmall}
          margin-bottom: ${theme.x3spacePx}px;
          padding-left: 18px;
          li {
            list-style-type: square;
            margin-bottom: 12px;
            &::marker {
              color: ${theme.color.brand03};
            }
          }
        }
        h3 {
          ${theme.typography.xSmallStrong}
          color: ${theme.color.white};
        }
      `}
  }
`;

export const ScrollPane = styled(Grid)<Props>`
  ${({ theme, criteriaVisible }) =>
    criteriaVisible
      ? css`
          overflow-x: auto;
          margin-left: -${theme.x2spacePx}px;
          margin-right: -${theme.x2spacePx}px;
        `
      : css`
          ${media.mdDown`
            padding-left: ${theme.x4spacePx}px;
          `}
        `}
`;

export const Tiles = styled(Grid)<Props>`
  ${({ theme, criteriaVisible }) => {
    if (criteriaVisible) {
      return css`
        padding-left: ${theme.x2spacePx}px;
        padding-right: ${theme.x2spacePx}px;
        ${media.mdDown`
          margin-bottom: ${theme.x2spacePx}px;
        `}
      `;
    }
    // Override the grid here to allow for an inline flow of the criteria title
    return css`
      display: block;
    `;
  }}
`;

export const CallToAction = styled(Grid)<Props>`
  ${media.mdDown`
  ${({ theme, criteriaVisible }) =>
    criteriaVisible === false &&
    css`
      padding-left: ${theme.x4spacePx}px;
    `}
  `}
`;

export const ChevronRight = styled(ChevronRightSmallSolid)``;

export const Label = styled(Grid)<Props>`
  margin: 0;
  background: ${({ theme }) => theme.color.goodRGBA(0.1)};
  border-radius: ${({ theme }) => theme.x1spacePx / 2}px;
  ${({ theme }) => theme.typography.xSmallStrong}
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  padding-left: ${({ theme }) => theme.x1spacePx / 2}px;
  svg > * {
    fill: ${({ theme }) => theme.color.good};
  }
  ${({ theme, criteriaVisible }) =>
    criteriaVisible
      ? css`
          padding-right: ${theme.x2spacePx}px;
          padding-left: ${theme.x2spacePx}px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        `
      : css`
          /* A height is needed here to help Safari recalculate this grid layout */
          height: ${theme.x4spacePx}px;
          margin-right: ${theme.x1spacePx}px;
          margin-bottom: ${theme.x1spacePx}px;
        `}
`;

export const Icon = styled(Grid)`
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  svg > * {
    fill: ${({ theme }) => theme.color.good};
  }
`;

export const Headline = styled(Grid)`
  ${({ theme }) => theme.typography.baseStrong}
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  svg > * {
    fill: ${({ theme }) => theme.color.chart04};
  }
`;
